import React, { forwardRef } from "react";
import { APP_IMAGES } from "../../constants/images";
import { cn } from "../../utils/cn";
import Qrcode from "../qrcode";
import TextInput from "../inputs/TextInput";

const PrintableBadgeCard = forwardRef<
  HTMLDivElement,
  { visitorInfo: any[]; visitorPhoto: string; qrCode: string }
>(({ visitorInfo, visitorPhoto, qrCode }, ref) => (
  <div ref={ref}>
    <div
      id="printable-badge"
      className="relative w-screen h-screen bg-white overflow-hidden shadow-md"
    >
      <div
        className="absolute top-0 right-0  w-screen h-screen bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url(${APP_IMAGES.printBg})`,
        }}
      />
      <div className="h-full flex flex-col items-center p-3 w-full max-w-md mx-auto">
        <img
          src={APP_IMAGES.logo}
          alt="logo"
          className="w-[90px] object-contain mb-5"
        />

        <div className="w-full relative">
          {visitorPhoto && (
            <div className="w-[60px] h-[60px] bg-white ring-4 ring-white rounded-full mx-auto overflow-hidden absolute -top-3 left-1/2 transform -translate-x-1/2 z-20">
              <img
                src={visitorPhoto}
                alt="visitor-photo"
                className="w-full h-full object-contain"
              />
            </div>
          )}

          <div
            className={cn(
              "bg-white/70 rounded-lg mx-auto z-10 px-3.5 py-0 flex flex-col items-center justify-center w-full gap-1 mt-3",
              visitorPhoto ? "pt-[25px]" : "pt-[10px]"
            )}
          >
            <div className="flex items-center justify-between w-full px-3">
              <p className="font-bold text-[9px]">Visitor Card</p>
              <p className="font-bold text-[9px]">بطاقة زائر</p>
            </div>

            <div className="flex flex-col gap-1 mt-0.5 w-full">
              {visitorInfo
                .filter((item) => item.value)
                .map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-col gap-0.5 bg-green-pastel py-0.5 px-3 rounded-md"
                  >
                    <div className="flex items-center justify-between">
                      <p className="font-medium text-[7px]">{item.titleEn}</p>
                      <p className="font-medium text-[7px]">{item.titleAr}</p>
                    </div>
                    <div
                      className={cn(
                        "flex items-center justify-center",
                        item.styles
                      )}
                    >
                      <p className="font-semibold text-[8px] line-clamp-1">
                        {item.value}
                      </p>
                    </div>
                  </div>
                ))}

              {/* <TextInput className="!py-1 !rounded-md -mt-0.5" /> */}

              {qrCode && (
                <div className="mx-auto -mt-0.5">
                  <Qrcode value={qrCode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
));

export default React.memo(PrintableBadgeCard);
